export default function Hero() {
  return (
    <section id="home" className="relative w-full min-h-[92vh] flex items-center">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=anime%20illustration%20artboard%20scene%20with%20open%20artbooks%2C%20brushes%2C%20colorful%20palette%20and%20prints%20arranged%20on%20a%20warm%20desk%2C%20soft%20golden%20and%20coral%20light%2C%20creative%20workshop%20vibe%2C%20artistic%20doujin%20culture%2C%20dreamy%20warm%20tone%2C%20high%20detail&width=1600&height=900&seq=doujin-hero-01&orientation=landscape"
          alt="同人本子高清原图与画集在线浏览"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/60 via-foreground-950/45 to-background-50"></div>
      </div>

      <div className="container-x relative z-10 py-24 md:py-28 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/15 backdrop-blur border border-background-50/30 mb-6">
          <span className="w-2 h-2 rounded-full bg-accent-400"></span>
          <span className="text-sm text-background-50">同人本子官网 · 持续更新中</span>
        </div>

        <h1 className="text-foreground-50 font-heading text-3xl md:text-5xl leading-tight max-w-3xl mx-auto">
          同人本子高清原图
          <span className="block text-accent-300 mt-2">画集 · 图包 在线浏览</span>
        </h1>

        <p className="mt-6 text-base md:text-lg text-background-50/90 max-w-2xl mx-auto leading-relaxed">
          汇聚热门作品同人插画与成套图包，画质清晰、分类细致、更新迅速。无论是收藏欣赏，还是画师参考，都能在这里找到心仪的作品。
        </p>

        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="#gallery"
            className="px-7 py-3 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            开始在线浏览
          </a>
          <a
            href="#category"
            className="px-7 py-3 rounded-md bg-background-50/15 backdrop-blur border border-background-50/40 text-background-50 text-sm font-semibold hover:bg-background-50/25 transition-colors whitespace-nowrap"
          >
            查看作品分类
          </a>
        </div>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-4 max-w-3xl mx-auto">
          {[
            { num: "4500+", label: "收录画集" },
            { num: "12000+", label: "高清原图" },
            { num: "98%", label: "清晰度好评" },
            { num: "每周", label: "持续更新" },
          ].map((stat) => (
            <div
              key={stat.label}
              className="px-4 py-4 rounded-lg bg-background-50/10 backdrop-blur border border-background-50/20"
            >
              <p className="font-heading text-2xl text-accent-300">{stat.num}</p>
              <p className="mt-1 text-xs text-background-50/80">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}